console.log("\n%c Charts", "color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #2563EB, #82a0e2);background-origin: border-box;background-clip: padding-box, border-box;")

import { $$ } from '@/utilities/helpers';
import { initBarChart } from '@/charts/bar';
import { initLineChart } from '@/charts/line';
import { initDoughnutChart } from '@/charts/doughnut';

/**
 * 
 * Doughnut charts
 * 
 */
$$('.js-inline-doughnut').forEach($chart => initDoughnutChart($chart));


/**
 * 
 * Horizontal bar charts
 * 
 */
$$('.js-inline-horizontal-bar-chart').forEach($chart => initBarChart($chart));


/**
 * 
 * Line charts
 * 
 */
$$('.js-inline-line-chart').forEach($chart => initLineChart($chart));